<script lang="ts">
import type {PropType} from "vue";

import {defineComponent} from "vue";

export default defineComponent({
  name: "Icon",
  props: {
    icon: {
      type: String,
      default: ''
    },

    iconClass: {
      type: String,
      default: 'default-icon'
    },

    callback: {
      type: Function as PropType<() => unknown>,
    },
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {},

  methods: {
    async startAsyncTask() {
      if (this.loading || (this as typeof this & {disabled?: boolean}).disabled) return;

      this.loading = true

      try {
        await this.callback!()
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  }
});
</script>

<template>
  <div @click.stop="startAsyncTask()">
    <div class="icon-container d-flex align-items-center justify-content-center" :class="iconClass">
      <slot/>
    </div>
  </div>
</template>

<style lang="scss">

.icon-container {
  width: 25px;
  height: 25px;

  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.1);

  cursor: pointer;

  transition: all 0.3s ease;

  &.default-icon {
    svg {
      filter: invert(86%) sepia(0%) saturate(0%) hue-rotate(85deg) brightness(106%) contrast(93%);
    }
  }

  &:hover {
    background: rgba(255, 255, 255, 0.2);

    border-radius: 2px;
    border-color: rgba(255, 255, 255, 0.4);

    svg {
      filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(160deg) brightness(102%) contrast(101%);
    }
  }
}

.zoom-restart-icon, .zoom-in-icon, .zoom-out-icon {
  background: linear-gradient(0deg, rgba(39, 48, 51, 1) 0%, rgba(39, 48, 51, 0.9) 100%);

  border: 1px solid rgba(184, 232, 255, 0.2);
  border-radius: 2px;
}

.zoom-restart-icon {
  position: absolute;
  left: 10px;
  bottom: 10px;
}

.zoom-in-icon {
  position: absolute;
  bottom: 45px;
  right: 10px;
}

.zoom-out-icon {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

</style>
